<template>
  <main id="download-app">
    <img :src="`${publicPath}/screen.png`" />
    <h1>ดาวน์โหลดแอป FINNOMENA</h1>
    <p>เปิดบัญชีเพื่อลงทุนได้ทันที ฟรี ! ไม่มีค่าใช้จ่าย</p>
    <a
      data-action="click_download_ios"
      href="https://itunes.apple.com/app/apple-store/id1182358897?pt=118448546&ct=LINE%20Create%20Plan&mt=8"
    >
      <img class="badge" :src="`${publicPath}/app-store-badge.png`" />
    </a>
    <a
      data-action="click_download_android"
      href="https://play.google.com/store/apps/details?id=com.finnomena.finnomena&referrer=utm_source%3DLINE%26utm_medium%3DFINNOMENA%26utm_campaign%3DLINE%2520Create%2520Plan"
    >
      <img class="badge" :src="`${publicPath}/google-play-badge.png`" />
    </a>
  </main>
</template>
<script>
export default {
  data() {
    return {
      publicPath: process.env.VUE_APP_SCONTENT_URL + "/line-liff/plan",
      objQuery: {}
    };
  },
  props: { userID: String, env: Object, finnakies: String },
  metaInfo: {
    title: "FINNOMENA PORT"
  },
  async mounted() {},
  async created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.header-finno {
  display: none;
}
.footer {
  display: none;
}
#download-app {
  text-align: center;
  padding-top: 40px;
  h1 {
    @extend %font-size-l;
    margin-top: 32px;
    font-weight: bold;
    margin-bottom: 6px;
  }
  p {
    @extend %font-size-m;
    color: $color-secondary-text;
  }
  .badge {
    margin: 24px 3px;
  }
}
</style>
